import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { Group, IGetGroupListResponse } from './interfaces';

export const getGroupList = async (): Promise<Group[]> => {
  const response: AxiosResponse<IGetGroupListResponse> = await apiClient.get(
    '/groups/list'
  );

  return response.data.data;
};
